/* H Town Hemp interactions for Taste 16 */
(function () {
  'use strict';

  /* ---------- Add to basket (uses the theme's cart drawer / notification) ---------- */
  function addToCart(button) {
    var scope = button.closest('[data-ht-buy]') || button.parentElement;
    var select = scope ? scope.querySelector('[data-ht-variant]') : null;
    var variantId = select ? select.value : button.dataset.variantId;
    var errorEl = scope ? scope.parentElement.querySelector('[data-ht-error]') : null;
    if (!variantId) return;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { id: Number(variantId), quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }

    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    if (errorEl) errorEl.textContent = '';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (errorEl) errorEl.textContent = res.description || res.message || 'This item could not be added.';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'htown', productVariantId: variantId, cartData: res });
        }
        if (cart && typeof cart.renderContents === 'function' && res.sections) {
          cart.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        if (errorEl) errorEl.textContent = 'Something went wrong. Refresh the page and try again.';
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ht-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* Keep the price label in sync with the chosen weight */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ht-variant]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var root = sel.closest('[data-ht-product]');
    var priceEl = root && root.querySelector('[data-ht-price]');
    if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price.replace(/<[^>]*>/g, '');
  });

  /* ---------- Strain finder ---------- */
  function initFinder(root) {
    if (root.dataset.htReady) return;
    root.dataset.htReady = '1';
    var grid = root.querySelector('[data-ht-strains]');
    var empty = root.querySelector('[data-ht-empty]');
    var sort = root.querySelector('[data-ht-sort]');
    var chips = root.querySelectorAll('[data-ht-filter]');
    var filter = 'all';

    function matches(card) {
      if (filter === 'all') return true;
      if (filter === 'new') return card.dataset.new === 'true';
      if (filter === 'indoor') return card.dataset.grow === 'indoor';
      if (filter === 'day' || filter === 'evening') return card.dataset.time === filter || card.dataset.time === 'any';
      return true;
    }

    function apply() {
      var cards = Array.prototype.slice.call(grid.children);
      var shown = 0;
      cards.forEach(function (c) {
        var ok = matches(c);
        c.hidden = !ok;
        if (ok) shown++;
      });
      if (sort) {
        var by = sort.value;
        cards.sort(function (a, b) {
          var stock = (b.dataset.available === 'true') - (a.dataset.available === 'true');
          if (stock) return stock;
          if (by === 'price') return Number(a.dataset.price) - Number(b.dataset.price);
          if (by === 'cbd') return Number(b.dataset.cbd) - Number(a.dataset.cbd);
          return Number(a.dataset.index) - Number(b.dataset.index);
        }).forEach(function (c) { grid.appendChild(c); });
      }
      if (empty) empty.hidden = shown > 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        filter = chip.dataset.htFilter;
        apply();
      });
    });
    if (sort) sort.addEventListener('change', apply);
    apply();
  }

  /* ---------- Age check ---------- */
  function initGate(gate) {
    if (gate.dataset.htReady) return;
    gate.dataset.htReady = '1';
    var key = 'htown-age-ok';
    var ok = false;
    try { ok = window.localStorage.getItem(key) === '1'; } catch (err) {}
    if (gate.dataset.preview === 'true') ok = false;
    if (!ok) {
      gate.hidden = false;
      var yes = gate.querySelector('[data-ht-gate-yes]');
      if (yes) yes.focus();
    }
    gate.addEventListener('click', function (e) {
      if (!e.target.closest('[data-ht-gate-yes]')) return;
      gate.hidden = true;
      try { window.localStorage.setItem(key, '1'); } catch (err) {}
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ht-finder]').forEach(initFinder);
    (scope || document).querySelectorAll('[data-ht-gate]').forEach(initGate);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Re-init when sections are edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* ==================== Product page ==================== */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    format = format || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return withCommas;
      if (key === 'amount_with_comma_separator') return withCommas.replace(/,/g, '.') + ',' + parts[1];
      if (key === 'amount_no_decimals_with_comma_separator') return withCommas.replace(/,/g, '.');
      return withCommas + '.' + parts[1];
    });
  }

  /* "3.5g", "4 Grams", "1 Gram", "28 grams" -> number of grams; anything else -> null */
  function grams(text) {
    var m = String(text || '').match(/(\d+(?:\.\d+)?)\s*(g|gr|gram|grams)\b/i);
    return m ? parseFloat(m[1]) : null;
  }

  function initPdp(root) {
    if (root.dataset.htReady) return;
    root.dataset.htReady = '1';

    var variants = [];
    var moneyFormat = '£{{amount}}';
    try { variants = JSON.parse(root.querySelector('[data-ht-variants]').textContent); } catch (e) {}
    try { moneyFormat = JSON.parse(root.querySelector('[data-ht-money]').textContent); } catch (e) {}
    /* some currency apps wrap the shop's money format in HTML, e.g. <span class=money>; keep only the text */
    moneyFormat = String(moneyFormat).replace(/<[^>]*>/g, '');

    var idInput = root.querySelector('[data-ht-variant-id]');
    var priceEl = root.querySelector('[data-ht-price]');
    var compareEl = root.querySelector('[data-ht-compare]');
    var ppgEl = root.querySelector('[data-ht-ppg]');
    var pointsEl = root.querySelector('[data-ht-points]');
    var submit = root.querySelector('[data-ht-submit]');
    var submitText = root.querySelector('[data-ht-submit-text]');
    var qtyInput = root.querySelector('[data-ht-qty-input]');
    var stickyAdd = root.querySelector('[data-ht-sticky-add]');
    var stickySum = root.querySelector('[data-ht-sticky-sum]');
    var optionSets = root.querySelectorAll('[data-ht-option]');
    var pointsRate = Number(root.dataset.points || 0);
    var singleOption = optionSets.length === 1;

    function currentVariant() {
      if (!optionSets.length) return variants[0];
      var chosen = Array.prototype.map.call(optionSets, function (set) {
        var c = set.querySelector('input:checked');
        return c ? c.value : null;
      });
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
    }

    /* Price per gram + bulk savings on each pill (single weight option only) */
    var bestPpg = null;
    if (singleOption) {
      var maxPpg = 0;
      variants.forEach(function (v) {
        var g = grams(v.options[0]);
        if (g) {
          v.ppg = v.price / g;
          if (v.ppg > maxPpg) maxPpg = v.ppg;
        }
      });
      optionSets[0].querySelectorAll('label').forEach(function (label) {
        var input = label.querySelector('input');
        var v = variants.find(function (x) { return x.options[0] === input.value; });
        var saveEl = label.querySelector('[data-ht-save]');
        if (!v) return;
        if (!v.available) label.classList.add('is-unavailable');
        if (v.ppg && maxPpg) {
          var pct = Math.round((1 - v.ppg / maxPpg) * 100);
          if (pct >= 5 && saveEl) { saveEl.textContent = 'Save ' + pct + '%'; saveEl.hidden = false; }
        }
      });
      bestPpg = maxPpg;
    } else {
      /* multi-option: flag values with no available variant for the other current choices */
      optionSets.forEach(function (set) { set.addEventListener('change', markUnavailable); });
    }

    function markUnavailable() {
      optionSets.forEach(function (set, i) {
        set.querySelectorAll('label').forEach(function (label) {
          var val = label.querySelector('input').value;
          var others = Array.prototype.map.call(optionSets, function (s) { var c = s.querySelector('input:checked'); return c ? c.value : null; });
          others[i] = val;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, j) { return o === others[j]; }); });
          label.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function update(fromUser) {
      var v = currentVariant();
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (!v) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = 'Unavailable';
        if (stickyAdd) stickyAdd.disabled = true;
        return;
      }
      idInput.value = v.id;
      var total = v.price * qty;
      priceEl.textContent = formatMoney(total, moneyFormat);
      if (compareEl) {
        var showCompare = v.compare > v.price;
        compareEl.hidden = !showCompare;
        if (showCompare) compareEl.textContent = formatMoney(v.compare * qty, moneyFormat);
      }
      if (ppgEl) {
        var g = grams(v.options[0]);
        ppgEl.textContent = g ? formatMoney(Math.round(v.price / g), moneyFormat) + ' per gram' : '';
      }
      if (pointsEl) pointsEl.textContent = Math.floor(total / 100 * pointsRate) + ' points';
      if (submit) submit.disabled = !v.available;
      if (submitText) submitText.textContent = v.available ? 'Add to basket' : 'Sold out';
      if (stickyAdd) stickyAdd.disabled = !v.available;
      if (stickySum) stickySum.textContent = (variants.length > 1 ? v.title + (qty > 1 ? ' × ' + qty : '') + ', ' : '') + formatMoney(total, moneyFormat);

      if (fromUser) {
        if (v.media) showMedia(String(v.media));
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }

    optionSets.forEach(function (set) { set.addEventListener('change', function () { update(true); }); });

    /* Quantity stepper */
    root.querySelectorAll('[data-ht-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = (parseInt(qtyInput.value, 10) || 1) + Number(btn.dataset.htQty);
        qtyInput.value = Math.min(99, Math.max(1, n));
        update(false);
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      qtyInput.value = Math.min(99, Math.max(1, parseInt(qtyInput.value, 10) || 1));
      update(false);
    });

    /* Gallery */
    var mainImg = root.querySelector('[data-ht-main-img]');
    var thumbs = root.querySelectorAll('[data-ht-thumb]');
    function showMedia(id) {
      var thumb = root.querySelector('[data-ht-thumb][data-media-id="' + id + '"]');
      if (!thumb || !mainImg) return;
      mainImg.src = thumb.dataset.src;
      mainImg.srcset = thumb.dataset.srcset;
      mainImg.alt = thumb.dataset.alt;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.mediaId); });
    });

    /* Same-day dispatch countdown in UK time */
    var dispatchEl = root.querySelector('[data-ht-dispatch]');
    var cutoff = Number(root.dataset.cutoff || 15);
    function tick() {
      if (!dispatchEl || !window.Intl) return;
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var get = function (k) { var p = parts.find(function (x) { return x.type === k; }); return p ? p.value : ''; };
      var day = get('weekday'), h = Number(get('hour')) % 24, m = Number(get('minute'));
      var weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(day) > -1;
      var mins = cutoff * 60 - (h * 60 + m);
      if (weekday && mins > 0) {
        var hh = Math.floor(mins / 60), mm = mins % 60;
        dispatchEl.innerHTML = 'Order within <span class="ht-countdown">' + (hh ? hh + 'h ' : '') + mm + 'm</span> for dispatch today';
      } else {
        dispatchEl.textContent = (day === 'Fri' || day === 'Sat' || day === 'Sun') ? 'Order now for dispatch on Monday' : 'Order now for dispatch tomorrow';
      }
    }
    tick();
    setInterval(tick, 30000);

    /* Sticky mobile basket bar */
    var sticky = root.querySelector('[data-ht-sticky]');
    if (sticky && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = on ? 0 : -1;
      }).observe(submit);
    }
    if (stickyAdd) stickyAdd.addEventListener('click', function () {
      var form = root.querySelector('form[data-type="add-to-cart-form"]');
      if (!form || submit.disabled) return;
      if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
    });

    if (!singleOption && optionSets.length) markUnavailable();
    update(false);
  }

  /* Related products: swap in Shopify's recommendations once the page is idle */
  function initRelated(section) {
    if (section.dataset.htReady || !section.dataset.url) return;
    section.dataset.htReady = '1';
    var load = function () {
      fetch(section.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ht-related-grid]');
          var grid = section.querySelector('[data-ht-related-grid]');
          if (fresh && grid && fresh.children.length) grid.innerHTML = fresh.innerHTML;
          if (grid && !grid.children.length) section.hidden = true;
        })
        .catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(section);
    } else { load(); }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ht-pdp]').forEach(initPdp);
    (scope || document).querySelectorAll('[data-ht-related]').forEach(initRelated);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();